var currentVersion;

export function handleVersionChange({ version, licenseSubType }) {
    return currentVersion = licenseSubType === 'Ancor' ? 'ANCOR' : version;
}

export function getVersion() {
    return currentVersion;
}

export function isHR() {
    return currentVersion === 'HR';
}

export function isKA() {
    return currentVersion === 'KA';
}

export function isAncor() {
    return currentVersion === 'ANCOR';
}

